import React, { FC, useState, useRef, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Viewer from 'react-viewer';
import { fetchData, postData, postFile } from '../Data/fetch';
import { useQuery, queryCache } from 'react-query';
import { IApplicationDocument } from '../Interfaces/Application/IApplicationDocument';
import { isSupportedDocument } from '../utils/files';
import { useQueryApplicationDocumentFile } from '../Data/ApplicationDocumentData';
import { useDispatch } from 'react-redux';
import { ApplicationDispatch } from '../store/application/types';

export interface ApplicationDocumentViewerProps {
  selectedDocument?: IApplicationDocument;
}

export const ApplicationDocumentViewer: FC<ApplicationDocumentViewerProps> = props => {
  const selectedDocument = props.selectedDocument;
  const dispatch = useDispatch<ApplicationDispatch>();
  const [open, setOpen] = useState(false);
  const { data: selectedDocumentObjectUrl } = useQueryApplicationDocumentFile(dispatch, selectedDocument?.documentId, selectedDocument?.document?.name);
  const previewPaneRef = useRef<HTMLDivElement>(null);

  const handleOpen = () => {
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
    setIsReady(false);
  }

  const [isReady, setIsReady] = useState(false);
  useEffect(() => {
    if (open) {
      const timeout = setTimeout(() => {
        setIsReady(true);
      }, 0);
      return () => clearTimeout(timeout);
    }
  }, [selectedDocumentObjectUrl, open]);

  return (
    <div>
      <Button onClick={handleOpen} color="primary" variant="text">{(selectedDocument as any)?.document?.name}</Button>
      <Dialog
        fullWidth
        maxWidth="xl"
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            height: '100%',
          }
        }}
      >
        <DialogTitle>View Document</DialogTitle>
        <DialogContent>
          <div ref={previewPaneRef} style={{
            height: '100%',
          }}>
            {!selectedDocumentObjectUrl || !isReady ?
              <></>
              : isSupportedDocument(selectedDocument?.mimeType) ?
                <Viewer
                  key={selectedDocument?.name}
                  visible={!!selectedDocumentObjectUrl}
                  images={[{
                    src: selectedDocumentObjectUrl || '',
                    alt: selectedDocument?.name,
                  }]}
                  container={previewPaneRef?.current || undefined}
                  noClose
                  noNavbar
                  noImgDetails
                  changeable={false}
                  showTotal={false}
                />
                :
                <iframe src={selectedDocumentObjectUrl}
                  width="97%"
                  height="97%"
                  style={{
                    maxHeight: "95vh",
                    height: '100%',
                  }}
                >
                  iframes not supported.
                </iframe>
            }
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
